import { $globalSanityClient } from '@/sanity';
import { diseasesQuery } from './diseasesQuery';
import UIDiseaseListingSection from './DiseaseListingSection.client';

export default async function DiseaseListingSection() {
  const diseases = await $globalSanityClient.fetch<(typeof diseasesQuery)[1]>(
    diseasesQuery[0]
  );

  return <UIDiseaseListingSection diseases={diseases} />;
}
